import React, { useEffect, useMemo, useState } from "react";
import Pagination from "../../components/Pagination/Pagination";
import { getBookNowSubmissions } from "../../utils/bookings";
import "./Bookings.scss";

const formatDateTime = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch {
    return String(timestamp);
  }
};

const Bookings = () => {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [q, setQ] = useState("");

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const load = async () => {
    try {
      setError(null);
      const data = await getBookNowSubmissions();
      setAll(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setError("Failed to load bookings. Please check API /api/register/bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    const interval = setInterval(load, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setPage(1);
  }, [q, perPage]);

  const filtered = useMemo(() => {
    if (!q.trim()) return all;
    const s = q.trim().toLowerCase();
    return all.filter((r) => {
      const hay = `${r.name || ""} ${r.phone || ""} ${r.email || ""} ${
        r.category || ""
      } ${r.sourcePage || ""}`.toLowerCase();
      return hay.includes(s);
    });
  }, [all, q]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
  const start = (page - 1) * perPage;
  const rows = filtered.slice(start, start + perPage);

  if (loading) return <div className="bookings-loading">Loading bookings…</div>;
  if (error)
    return (
      <div className="bookings-error">
        <h3>Error Loading Bookings</h3>
        <p>{error}</p>
        <button onClick={load}>Retry</button>
      </div>
    );

  return (
    <div className="bookings-page">
      <div className="bookings-header">
        <h2>
          <i className="ti-receipt" /> Book Now Submissions
        </h2>
        <div className="bookings-actions">
          <input
            type="text"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search name, phone, email, category…"
          />
        </div>
      </div>

      <div className="bookings-table-wrapper">
        <table className="bookings-table">
          <thead>
            <tr>
              <th>Date/Time</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Category</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, idx) => (
              <tr key={r.id || `${r.email}-${idx}`}>
                <td>{formatDateTime(r.submittedAt)}</td>
                <td>{r.name || "-"}</td>
                <td>{r.phone || "-"}</td>
                <td>{r.email || "-"}</td>
                <td>{r.category || "-"}</td>
                <td>{r.sourcePage || "-"}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  No bookings found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={page}
        totalPages={totalPages}
        onPageChange={(p) => setPage(Math.min(Math.max(1, p), totalPages))}
        itemsPerPage={perPage}
        totalItems={filtered.length}
        onItemsPerPageChange={setPerPage}
      />
    </div>
  );
};

export default Bookings;

